import React from 'react';
import { Field } from 'react-final-form';

type StringKeys<T> = Extract<keyof T, string>;

interface Props<T = any> {
    children: (values: Partial<T>) => React.ReactElement;
    fieldNames: StringKeys<T>[];
}

function FormSpyFieldValues<T = any>({
    children,
    fieldNames
}: Props<T>): React.ReactElement {
    return fieldNames.reduce(
        (accumulator: Function, fieldName: StringKeys<T>) => (
            values: Partial<T>
        ): React.ReactElement => (
            <Field name={fieldName} subscription={{ value: true }}>
                {({ input: { value } }): Partial<T> =>
                    accumulator({ ...values, [fieldName]: value })
                }
            </Field>
        ),
        children
    )({});
}

export default FormSpyFieldValues;
